import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription, 
    DataMapper, 
    NumberComponentCreator,
    StateComponentCreator,
    StateExcelDisplayCreator,
    ThousandSeparatorCreator,
    CustomPopUpContentDisplayStrategy,
} from  '../../../components/BPMTable/TableMapperCreator'
import InvoicePaymentPopupContent from '../../../pages/Invoice/InvoicePayment/InvoicePaymentPopupContent'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";



const unitQuery = `
  invoicePayment(id:$id){
    id
    state
    detail{
      date
      couponIdentifier
      value
    }
    group {
      id
    }
    invoice {
      id
      identifier
      totalCost
      dueDate
      date
      account {
        identifier
        description
        legalEntity{
          name
        }
        provider{
          name
          country{
            name
          }
        }
        site{
          id
          name
          address
          state
          country{
            name
          }
        }
      }
      totalCost
      billingRequest {
        driver {
          vendor {
            name
          }
          currency {
            code
          }
        }
      }
    }
}
`;

const InvoicePaymentsTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allInvoicePayments'), unitQuery}

const invoicePaymentStates = {
    'A_0': 'AVAILABLE',
    'A_1': 'ASSIGNED',
    'A_2': 'CLOSED',
}

class InvoicePaymentsTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InvoicePaymentsTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, InvoicePaymentsTableCreatorQueries)
        tableCreator.setInitialSortField('dueDate', 'desc')
        tableCreator.setPopupContentStrategy(new CustomPopUpContentDisplayStrategy(InvoicePaymentPopupContent));

        tableCreator.addDescriptions ([
            new TableFieldDescription(
              'invoicePaymentId',
              new DataMapper("id"),
              new f.FilterDescription(new f.TextFilter("invoicePaymentId")),
              {label: 'Reference Identifier', fieldAlign: 'right'}
            ),
            new TableFieldDescription(
              'invoiceId',
              new DataMapper("invoice.identifier"),
              new f.FilterDescription(new f.TextFilter("invoiceId")),
              {label: 'Identifier'}
            ),
            new TableFieldDescription(
              'invoiceTotalCost',
                new DataMapper("invoice.totalCost"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Total Cost', componentCreator: new ThousandSeparatorCreator(2), fieldAlign: 'right'}
            ),
            new TableFieldDescription(
              'dueDate',
              new DataMapper("invoice.dueDate"),
              new f.FilterDescription(new f.PeriodFilter("dueDate")),
              {label: 'Due Date'}
            ),
            new TableFieldDescription(
              'groupId',
              new DataMapper("group.id"),
              new f.FilterDescription(new f.TextFilter("groupId")),
              {label: 'APGL ID', fieldAlign: 'right'}
            ),
            new TableFieldDescription(
              'state',
              new DataMapper("state"),
              new f.FilterDescription(new f.InvoicePaymentStateFilter("state")),
              {
                label: 'State', 
                componentCreator: new StateComponentCreator(invoicePaymentStates),
                excelDisplay: new StateExcelDisplayCreator(invoicePaymentStates)
              }
            ),
            new TableFieldDescription(
              'accountId',
              new DataMapper("invoice.account.identifier"),
              new f.FilterDescription(new f.TextFilter("accountId")),
              {label: 'Account ID', fieldAlign: 'right'}
            ),
            new TableFieldDescription(
              'accountDescription',
              new DataMapper("invoice.account.description"),
              new f.FilterDescription(new f.TextFilter("accountDescription")),
              {label: 'Account Description'}
            ),
            new TableFieldDescription(
              'legalEntity',
              new DataMapper("invoice.account.legalEntity.name"),
              new f.FilterDescription(new f.TextFilter("legalEntity")),
              {label: 'Legal Entity'}
            ),
            new TableFieldDescription(
              'vendor',
              new DataMapper("invoice.billingRequest.driver.vendor.name"),
              new f.FilterDescription(new f.TextFilter("vendor")),
              {label: 'Vendor'}
            ),
            new TableFieldDescription(
              'vendorCountry',
              new DataMapper("invoice.account.site.country.name"),
              new f.FilterDescription(new f.TextFilter("country")),
              {label: 'Country', onlyForm: true}
            ),
            new TableFieldDescription(
              'invoiceDate',
              new DataMapper("invoice.date"),
              new f.FilterDescription(new f.PeriodFilter("invoiceDate")),
              {label: 'Invoice Date'}
            ),
            new TableFieldDescription(
              'date',
              new DataMapper("detail.date"),
              new f.FilterDescription(new f.PeriodFilter("date")),
              {label: 'Date'}
            ),
            new TableFieldDescription(
              'couponId',
              new DataMapper("detail.couponIdentifier"),
              new f.FilterDescription(new f.TextFilter("couponId")),
              {label: 'Coupon Identifier'}
            ),
            new TableFieldDescription(
              'value',
              new DataMapper("detail.value"),
              new f.FilterDescription(new f.NullCreator("value")),
              {
                label: 'Value',
                componentCreator: new NumberComponentCreator(this.parentProps.currentUserData.currency.symbol, 2),
                fieldAlign: 'right',
              }
            ),
            new TableFieldDescription(
              'siteName',
              new DataMapper("invoice.account.site.name"),
              new f.FilterDescription(new f.NullCreator("name")),
              {label: 'Site Name' , hidenField: true}
            ),
            new TableFieldDescription(
              'siteAddress',
              new DataMapper("invoice.account.site.address"),
              new f.FilterDescription(new f.NullCreator("address")),
              {label: 'Site Address' , hidenField: true}
            ),
            new TableFieldDescription(
              'siteState',
              new DataMapper("invoice.account.site.state"),
              new f.FilterDescription(new f.NullCreator("state")),
              {label: 'Site State' , hidenField: true}
            ),
            new TableFieldDescription(
              'siteCountry',
              new DataMapper("invoice.account.site.country.name"),
              new f.FilterDescription(new f.NullCreator("name")),
              {label: 'Site Country' , hidenField: true}
            ),
            new TableFieldDescription(
              'vendor2',
              new DataMapper("invoice.billingRequest.driver.vendor.name"),
              new f.FilterDescription(new f.NullCreator("name")),
              {label: 'Vendor' , hidenField: true}
            ),
            new TableFieldDescription(
              'currency',
              new DataMapper("invoice.billingRequest.driver.currency.code"),
              new f.FilterDescription(new f.NullCreator("code")),
              {label: 'Currency' , hidenField: true}
            ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InvoicePaymentsTableCreator)

export default InvoicePaymentsTableCreator
